// assets/db-comments.js
;(function(window, document){
  // ── load customer info ────────────────────────────────────────
  const customerMeta = document.querySelector('meta[name="customer"]');
  if (customerMeta) {
    try {
      window.customer = JSON.parse(customerMeta.content);
      window.customerLoggedIn = true;
    } catch (err) {
      console.warn('[db-comments] parse customer meta failed', err);
    }
  }

  const API_BASE = 'https://gear-db-proxy.onrender.com/comments';
  // Profiles API base (same proxy, no /comments suffix)
  const PROFILE_BASE = 'https://gear-db-proxy.onrender.com';
  // ── pagination config ───────────────────────────────────────────
  const ROOT_PAGE_SIZE = 20;     // how many root comments to render initially
  const REPLIES_CHUNK_SIZE = 5;  // how many replies to append per click
  // ── reactions config ────────────────────────────────────────────
  const REACTION_TYPES = ['👍','👎'];

  // ── tiny helper to print debug output ─────────────────────────
  function debug() {
    console.log.apply(console, ["[db-comments]"].concat(
      Array.prototype.slice.call(arguments)
    ));
  }

// Get a pristine fetch not touched by theme/Shopify scripts
let nativeFetch = window.fetch;
(function ensureNativeFetch(){
  try {
    const frame = document.createElement('iframe');
    frame.style.display = 'none';
    // about:blank iframe won't load shop scripts
    document.documentElement.appendChild(frame);
    if (frame.contentWindow && frame.contentWindow.fetch) {
      nativeFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
    }
  } catch (_) { /* fallback to window.fetch */ }
})();

async function postJSONNative(url, data) {
  const res = await nativeFetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // no credentials needed; backend keys off body, not cookies
    credentials: 'omit',
    body: JSON.stringify(data)
  });
  const rawText = await res.text();
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${rawText || 'error'}`);
  try { return JSON.parse(rawText); } catch { return {}; }
}

async function hydrateCommentsWithProfiles(comments) {
  if (!Array.isArray(comments)) return comments;

  // collect all IDs recursively
  const ids = new Set();
  const collect = (node) => {
    if (!node) return;
    const cid = String(node.customerId || '').replace(/\D/g,'');
    if (cid) ids.add(cid);
    (node.replies || []).forEach(collect);
  };
  comments.forEach(collect);

  if (!ids.size) return comments;

  try {
    const res = await fetch(`${PROFILE_BASE}/profiles/bulk?ids=${[...ids].join(",")}`);
    if (!res.ok) return comments;
    const profiles = await res.json(); // object map keyed by shopify_customer_id

    const apply = (node) => {
      if (!node) return;
      const cid = String(node.customerId || '').replace(/\D/g,'');
      const prof = profiles[cid];
      if (prof) {
        node.author = prof.display_name || node.author;
        node.avatar_url = prof.avatar_url || node.avatar_url;
        node.profile_url = prof.display_name
          ? `${PROFILE_BASE}/u/${encodeURIComponent(prof.display_name)}`
          : null;
      }
      (node.replies || []).forEach(apply);
    };
    comments.forEach(apply);

    return comments;
  } catch (e) {
    console.warn("[db-comments] bulk profile fetch failed", e);
    return comments;
  }
}

  // Fire a site-wide XP refresh (profile page listens for this)
  function afterXpAward() {
    try {
      window.dispatchEvent(new Event('gd:xp-changed'));
      // If the profile page is open, also force an immediate redraw:
      window.refreshEgStats?.();
      window.refreshEgProfile?.();
    } catch {}
  }

  // ── UI: status/errors inline (above list) ─────────────────────
  function ensureStatusBar(wrapper) {
    let bar = wrapper.querySelector('.quick-comments-status');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'quick-comments-status';
      bar.style.cssText = 'margin:.5em 0;font-size:12px;';
      wrapper.insertBefore(bar, wrapper.firstChild);
    }
    return bar;
  }
  function notify(wrapper, msg, type='info') {
    const bar = ensureStatusBar(wrapper);
    bar.textContent = msg;
    bar.style.color = (type === 'error') ? '#b00020' : '#444';
  }

  // ── fetch helper with friendly errors ─────────────────────────
async function fetchJSON(url, opts, wrapper) {
  const res = await fetch(url, opts);
  const rawText = await res.text();   // always consume once
  console.log("[db-comments] RAW response", res.status, rawText);

  // If success → try JSON, fallback to {}
  if (res.ok) {
    try { return JSON.parse(rawText); }
    catch { return {}; }
  }

  // If error → try parse message from rawText
  let message = '';
  try {
    const body = JSON.parse(rawText);
    message = body?.error || body?.message || '';
  } catch {
    message = rawText; // fall back to showing plain text
  }

  switch (res.status) {
    case 413: message ||= 'Comment is too long.'; break;
    case 429: message ||= 'You’re posting too quickly. Please slow down.'; break;
    case 403: message ||= 'You can only edit/delete your own comment.'; break;
    case 400: message ||= 'Your request is invalid.'; break;
    default:  message ||= 'Server error—please try again.';
  }
  if (wrapper) notify(wrapper, message, 'error');
  throw new Error(`HTTP ${res.status}: ${message}`);
}

  // ── naming helpers ────────────────────────────────────────────
  function getCurrentUserName() {
    if (!window.customer) return '';
    const d = window.customer.display_name?.trim();
    if (d) return d;
    const fn = (window.customer.first_name  || '').trim();
    const ln = (window.customer.last_name   || '').trim();
    return [fn, ln].filter(Boolean).join(' ');
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;");
  }

  function formatTimeAgo(iso) {
    const d = new Date(iso);
    const s = Math.floor((Date.now() - d.getTime()) / 1000);

    if (s < 5) return 'just now';
    if (s < 60) return `${s} second${s === 1 ? '' : 's'} ago`;

    const m = Math.floor(s / 60);
    if (m < 60) return `${m} minute${m === 1 ? '' : 's'} ago`;

    const h = Math.floor(m / 60);
    if (h < 24) return `${h} hour${h === 1 ? '' : 's'} ago`;

    const dys = Math.floor(h / 24);
    if (dys < 30) return `${dys} day${dys === 1 ? '' : 's'} ago`;

    const mo = Math.floor(dys / 30);
    if (mo < 12) return `${mo} month${mo === 1 ? '' : 's'} ago`;

    const y = Math.floor(dys / 365);
    return `${y} year${y === 1 ? '' : 's'} ago`;
  }

function refreshTimeAgo(container) {
  const els = container.querySelectorAll('time.timeago[datetime]');
  els.forEach(el => {
    const raw = el.getAttribute('datetime');
    if (!raw) return;

    // Support numeric timestamps (ms) as strings
    const value = /^\d+$/.test(raw) ? Number(raw) : raw;
    const plain = el.dataset.style === 'plain';
    const text = formatTimeAgo(value);
    el.textContent = plain ? `${text}` : `• ${text}`;
  });
}

function countDescendants(node) {
  if (!node || !Array.isArray(node.replies)) return 0;
  let total = node.replies.length;
  for (const r of node.replies) total += countDescendants(r);
  return total;
}

function countAllNonDeleted(list) {
  let total = 0;
  const walk = (node) => {
    if (!node) return;
    if (!node.deleted) total += 1; // count only non-deleted
    if (Array.isArray(node.replies)) node.replies.forEach(walk);
  };
  (Array.isArray(list) ? list : []).forEach(walk);
  return total;
}

function ensureReactionStyles() {
  if (document.getElementById('quick-reactions-css')) return;
  const css = `
    .quick-react-btn .emoji {
      filter: grayscale(100%);
      opacity: .55;
      transition: filter .15s ease, opacity .15s ease;
    }
    .quick-react-btn.has-count .emoji,
    .quick-react-btn[aria-pressed="true"] .emoji {
      filter: none;
      opacity: 1;
    }
  `;
  const style = document.createElement('style');
  style.id = 'quick-reactions-css';
  style.textContent = css;
  document.head.appendChild(style);
}

let _profileHydrated = false;
async function hydrateDisplayNameOnce() {
  if (_profileHydrated) return;
  _profileHydrated = true;

  try {
    const cid = window.customer?.shopify_customer_id || window.customer?.id;
    if (!cid) return;

    const url = `${PROFILE_BASE}/profiles/me?customerId=${encodeURIComponent(cid)}`;
    const res = await fetch(url, { credentials: 'omit' });
    if (!res.ok) return;

    const data = await res.json().catch(() => ({}));
    const name = data?.profile?.display_name;
    if (name && typeof name === 'string') {
      window.customer.display_name = name;
    }

    // ✅ Add this to ensure window.customer.id is set
    if (typeof data?.profile?.shopify_customer_id === 'number') {
      window.customer.id = data.profile.shopify_customer_id;
    }

    // ⬅️ NEW: capture staff flag so UI can show staff-only actions
    if (typeof data?.profile?.is_staff !== 'undefined') {
      window.customer.is_staff = !!data.profile.is_staff;
    }
  } catch (_) {
    // swallow — comments should still work with metafield/full name fallback
  }
}

 window.initCommentsWidget = async function(containerEl, productId, productMeta = {}) {
   // 🔑 ensure numeric productId
  productId = String(productId);
  const productTitle  = (productMeta.title      || document.querySelector('meta[name="product-title"]')?.content || '').trim();
  const productHandle = (productMeta.handle     || document.querySelector('meta[name="product-handle"]')?.content || '').trim();
  const productImage  = (productMeta.image_url  || document.querySelector('meta[property="og:image"]')?.content || '').trim();
  try {
    debug("initCommentsWidget()", productId);

    // Make sure we use the up-to-date display name from the profiles DB
    await hydrateDisplayNameOnce();

    // Bail safely if called too early or without a target
    if (!containerEl || !containerEl.querySelector) {
      // nothing to mount into — exit without throwing so other UI (like quick view) keeps working
      return;
    }
    if (!productId) {
      // no product id — exit quietly
      return;
    }

    // ── teardown old widget ────────────────────────────────────────
    containerEl.querySelector('#quick-comments-widget')?.remove();

    // ── build wrapper & list ───────────────────────────────────────
    const wrapper = document.createElement('div');

    // Strip any theme-provided login form; we only show login at top of Reviews
  if (!window.customerLoggedIn) {
    const selectors = [
      'form[action*="/account/login"]',
      '#CustomerLoginForm',
      '.customer-login',
      'form#login'
    ];
    selectors.forEach(sel => {
      containerEl.querySelectorAll(sel).forEach(el => el.remove());
    });
  }

    wrapper.id = 'quick-comments-widget';
    wrapper.innerHTML = `<h3>Comments <span id="quick-comments-count" aria-live="polite"></span></h3><ul id="quick-comment-list"></ul>`;
    containerEl.appendChild(wrapper);
    ensureReactionStyles();

    const list = wrapper.querySelector('#quick-comment-list');

    // root pagination state
    let allComments = [];      // roots we've fetched so far (each includes nested replies)
    let renderedCount = 0;     // how many roots are currently rendered
    let nextCursor = null;     // server cursor for next page; null means no more
    let isLoadingPage = false; // guard to prevent double fetches

    // per-branch reply state: parentId -> { shown: number, all: Array }
    const repliesMap = new Map();

    // root "load older" button
    const loadMoreRootBtn = document.createElement('button');
    loadMoreRootBtn.id = 'quick-comments-more';
    loadMoreRootBtn.type = 'button';
    loadMoreRootBtn.style.cssText = 'margin-top:.5em;';
    loadMoreRootBtn.hidden = true;
    wrapper.appendChild(loadMoreRootBtn);

    loadMoreRootBtn.addEventListener('click', async () => {
      // First, render anything we already have but haven’t shown yet
      if (renderedCount < allComments.length) {
        renderRootPage(false);
        refreshTimeAgo(wrapper);
        return;
      }
      // Otherwise, ask the server for the next page (if available)
      if (nextCursor && !isLoadingPage) {
        await fetchNextPage();
        renderRootPage(false);
        refreshTimeAgo(wrapper);
      }
    });

    const storeKey = `comments:collapsed:${productId}`;
    let collapsedSet = new Set();
    try {
      const arr = JSON.parse(localStorage.getItem(storeKey) || '[]');
      if (Array.isArray(arr)) collapsedSet = new Set(arr);
    } catch {}

function saveCollapsed() {
  try {
    localStorage.setItem(storeKey, JSON.stringify([...collapsedSet]));
  } catch {}
}

function keyOf(id) { return String(id); }

function renderRepliesChunk(parentNode, repliesContainer, parentDepth, rootId, blockEl) {
  const key = keyOf(parentNode.id);
  const all = Array.isArray(parentNode.replies) ? parentNode.replies : [];

  // get state; if missing, initialize using what's already in the DOM
  let state = repliesMap.get(key);
  if (!state) {
    state = { shown: repliesContainer.children.length, all };
  } else {
    // keep array reference fresh
    state.all = all;
  }

  const next = Math.min(state.shown + REPLIES_CHUNK_SIZE, all.length);
  const chunk = all.slice(state.shown, next);

  // hydrate the batch asynchronously so UI doesn’t block
  hydrateCommentsWithProfiles(chunk).then(hydrated => {
    hydrated.forEach((child, idx) => {
      repliesContainer.appendChild(
        renderNode(child || chunk[idx], parentDepth + 1, rootId)
      );
    });
  });

  // advance counters immediately so “Load more replies” button updates correctly
  state.shown = next;
  repliesMap.set(key, state);

  // manage "Load more replies" button
  const block = blockEl || repliesContainer.parentElement; // .quick-replies-block
  if (!block) return;
  let moreBtn = block.querySelector('.load-more-replies');
  const remaining = all.length - state.shown;

  if (remaining > 0) {
    if (!moreBtn) {
      moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'load-more-replies';
      moreBtn.dataset.parentId = String(parentNode.id);
      block.appendChild(moreBtn);
    }
    moreBtn.textContent = `Load more replies (${remaining})`;
    moreBtn.hidden = false;
  } else if (moreBtn) {
    moreBtn.hidden = true;
  }

// keep button before the direct reply form (not nested)
const replyWrap = Array.from(block.children)
  .find(el => el.classList?.contains('quick-reply-wrap'));

if (replyWrap && moreBtn) {
  // ensure btn is in the same parent
  if (moreBtn.parentElement !== block) block.appendChild(moreBtn);
  // only insert if the ref node is actually our child
  if (replyWrap.parentElement === block && moreBtn.nextSibling !== replyWrap) {
    block.insertBefore(moreBtn, replyWrap);
  }
}
}

    function getReactionSummary(node) {
      // expected shape: node.reactions = { "👍": ["custId1","custId2"], ... }
      const res = {};
      const myId = window.customer?.shopify_customer_id || window.customer?.id;
      const obj = node && typeof node.reactions === 'object' ? node.reactions : {};
      for (const t of REACTION_TYPES) {
        const arr = Array.isArray(obj[t]) ? obj[t] : [];
        res[t] = { count: arr.length, mine: myId ? arr.includes(myId) : false };
      }
      return res;
    }

    // ── helpers to render a thread recursively ─────────────────────
    function renderNode(node, depth, rootId) {
      const isReply   = depth > 0;
      const isDeleted = Boolean(node.deleted);
      const who = isDeleted ? '[deleted]' :
        ((node.author && node.author !== 'You') ? node.author : 'Anonymous');

  // NEW: count all descendants (you already added countDescendants)
  const replyCount = countDescendants(node);

  const li = document.createElement('li');
  if (isDeleted) li.dataset.deleted = "true";
  li.className = isReply ? 'quick-reply' : 'quick-comment';
  li.dataset.id      = node.id;
  li.dataset.rootId  = rootId;
  li.dataset.isReply = isReply ? 'true' : 'false';
  li.dataset.text    = encodeURIComponent(node.text || '');
  li.dataset.depth   = String(depth);

  const thread = document.createElement('div');
  thread.className = 'quick-thread';
  thread.style.position = 'relative'; // ➕ ensure positioning for the rail toggle

const span = document.createElement('span');
span.className = isReply ? 'quick-reply-text' : 'quick-comment-text';

// Prefer an explicit created timestamp if the API provides it
const createdRaw =
  node.createdAt || node.created_at || node.created || node.date;
const createdAt = new Date(createdRaw);
const createdValid = !Number.isNaN(createdAt.getTime());
const createdIso = createdValid ? createdAt.toISOString() : new Date().toISOString();

// Possible updated/edited timestamp from API
let updatedRaw =
  node.editedAt || node.updatedAt || node.updated_at || node.edited_at || null;

// Some backends overwrite `date` on edit. If created exists and `node.date` > created,
// treat `node.date` as the edited time.
if (!updatedRaw && node.date && createdAt.getTime()) {
  const d = new Date(node.date);
  if (!Number.isNaN(d.getTime()) && d.getTime() > createdAt.getTime()) {
    updatedRaw = node.date;
  }
}

const updatedAt = updatedRaw ? new Date(updatedRaw) : null;
let editedHTML = '';

if (
  updatedAt &&
  !Number.isNaN(updatedAt.getTime()) &&
  createdValid &&
  updatedAt.getTime() > createdAt.getTime() // only if newer than created
) {
  const yr = updatedAt.getFullYear().toString().slice(-2); // short year (25)
  const title = `${updatedAt.getDate()}/${updatedAt.getMonth() + 1}/${yr}, ${updatedAt.toLocaleTimeString()}`;
  editedHTML =
    ` <span class="edited-badge">(edited <time data-style="plain" datetime="${escapeHtml(updatedAt.toISOString())}" title="${escapeHtml(title)}">${escapeHtml(formatTimeAgo(updatedAt.toISOString()))}</time>)</span>`;
}

const when  = createdValid ? formatTimeAgo(createdIso) : 'just now';
const exact = createdValid ? createdAt.toLocaleString() : new Date().toLocaleString();
const fullText = isDeleted ? '[deleted]' : (node.text || '');

// (you) badge on your own comments
const youBadge = (window.customer?.id && node.customerId == window.customer.id)
  ? ' <span class="you-badge">(you)</span>'
  : '';

// clamp long text
const LIMIT = 300;
const needsClamp = fullText.length > LIMIT;
const shortText = needsClamp ? (fullText.slice(0, LIMIT) + '…') : fullText;

const avatar = node.avatar_url ? String(node.avatar_url).trim() : "";
  span.innerHTML = `
  <div class="quick-comments-author">
      ${node.profile_url
        ? `<a href="${escapeHtml(node.profile_url)}" target="_blank" rel="noopener"
              class="comment-user-link">
            ${
              avatar
                ? `<img src="${escapeHtml(avatar)}" alt="${escapeHtml(who)}">`
                : `<div class="avatar-fallback">
                      ${escapeHtml(
                        who.split(/\s+/).map(w => w[0]).join("").toUpperCase()
                      )}
                    </div>`
            }
            <strong>${escapeHtml(who)}</strong>
          </a>`
        : `<div>
            ${
              avatar
                ? `<img src="${escapeHtml(avatar)}" alt="${escapeHtml(who)}">`
                : `<div class="avatar-fallback">
                      ${escapeHtml(
                        who.split(/\s+/).map(w => w[0]).join("").toUpperCase()
                      )}
                    </div>`
            }
            <strong>${escapeHtml(who)}</strong>
          `}
      ${youBadge}
    <time class="timeago" datetime="${escapeHtml(createdIso)}" title="${escapeHtml(exact)}">• ${escapeHtml(when)}</time>${editedHTML}

  </div>
  ${needsClamp
    ? `
      <span class="body-short">${escapeHtml(shortText)}</span>
      <span class="body-full" hidden>${escapeHtml(fullText)}</span>
      <button type="button" class="read-more">Read more</button>
    `
    : `
      <span class="body-full">${escapeHtml(fullText)}</span>
    `
  }
`;
thread.appendChild(span);

// Build reactions UI (we'll place it into a combined bar later)
const reacts = document.createElement('div');
reacts.className = 'quick-reactions';
reacts.style.cssText = 'display:flex;gap:6px;flex-wrap:wrap;align-items:center;';

const summary = getReactionSummary(node);
REACTION_TYPES.forEach((t) => {
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'quick-react-btn';
  btn.dataset.type = t;
  btn.dataset.commentId = String(node.id);
  btn.dataset.rootId = String(rootId);
  btn.setAttribute('aria-pressed', summary[t].mine ? 'true' : 'false');
  btn.disabled = !window.customerLoggedIn;

  const count = summary[t].count;
  btn.innerHTML = count > 0
    ? `<span class="emoji">${t}</span> <span class="count">${count}</span>`
    : `<span class="emoji">${t}</span>`;

    // NEW: light up when count > 0 (and CSS also lights up when aria-pressed="true")
  btn.classList.toggle('has-count', count > 0);
  btn.style.cssText = 'padding:2px 6px;border:1px solid #e2e2e2;border-radius:10px;font-size:12px;line-height:1.2;opacity:0.9;';
  if (summary[t].mine) btn.style.outline = '2px solid #999';

  reacts.appendChild(btn);
});

// Controls row (Reply always if logged in; Edit if owner; Delete if owner OR staff; none if deleted)
const controls = document.createElement('div');
controls.className = 'quick-comment-controls';

if (window.customerLoggedIn) {
  const replyBtn = document.createElement('button');
  replyBtn.type = 'button';
  replyBtn.className = 'quick-reply-btn';
  replyBtn.textContent = 'Reply';
  controls.appendChild(replyBtn);

  if (!isDeleted) {
    const isOwner = String(node.customerId) === String(window.customer?.id);
    const isStaff = !!window.customer?.is_staff;

    // Edit → only the owner
    if (isOwner) {
      const editBtn = document.createElement('button');
      editBtn.className = 'quick-comment-edit-btn';
      editBtn.textContent = 'Edit';
      controls.appendChild(editBtn);
    }

    // Delete → owner OR staff
    if (isOwner || isStaff) {
      const delBtn = document.createElement('button');
      delBtn.className = 'quick-comment-delete-btn';
      delBtn.textContent = 'Delete';
      controls.appendChild(delBtn);
    }
  }
}

// ── Combined actions bar: reactions (left) + controls (right) ──
const bar = document.createElement('div');
bar.className = 'quick-actions-bar';

// reactions we built earlier
reacts.style.margin = '0';          // remove extra top/bottom margin
const controlsWrap = controls;      // reuse your existing controls div

bar.appendChild(reacts);
bar.appendChild(controlsWrap);
thread.appendChild(bar);

// On-rail toggle if this node has replies
if (Array.isArray(node.replies) && node.replies.length) {
  thread.classList.add('has-toggle');
  const toggle = document.createElement('button');
  toggle.type = 'button';
  toggle.className = 'rail-toggle';
  toggle.dataset.count = String(replyCount);

  // respect persisted state
  const isCollapsed = collapsedSet.has(node.id);
  if (isCollapsed) {
    li.classList.add('collapsed');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.title = `Show replies (${replyCount})`;
  } else {
    toggle.setAttribute('aria-expanded', 'true');
    toggle.title = `Hide replies (${replyCount})`;
  }
  thread.appendChild(toggle);
}

  // Replies + reply form
  const repliesBlock = document.createElement('div');
  repliesBlock.className = 'quick-replies-block';
  repliesBlock.dataset.block = 'replies'; // NEW: easy hook for toggling

const repliesContainer = document.createElement('ul');
repliesContainer.className = 'quick-replies';

repliesBlock.appendChild(repliesContainer);

if (window.customerLoggedIn) {
  const replyWrap = document.createElement('div');
  replyWrap.className = 'quick-reply-wrap';
  replyWrap.innerHTML = `
    <form class="quick-reply-form" style="display:none;margin-top:.5em;">
      <input type="text"
            class="hp-input-reply"
            autocomplete="off"
            tabindex="-1"
            style="position:absolute;left:-9999px"
            aria-hidden="true">
      <textarea class="quick-reply-input" rows="2"
        style="display:block;width:100%;margin-bottom:.5em;"
        placeholder="Write a reply…"></textarea>
      <div style="display:flex;gap:8px;">
        <button type="button" class="quick-reply-submit-btn">Reply</button>
        <button type="button" class="quick-reply-cancel-btn">Cancel</button>
      </div>
    </form>
  `;

  // ✅ insert reply form right after the actions bar
  const actionsBar = thread.querySelector('.quick-actions-bar');
  if (actionsBar && actionsBar.parentNode) {
    actionsBar.parentNode.insertBefore(replyWrap, actionsBar.nextSibling);
  } else {
    thread.appendChild(replyWrap);
  }
}

  // ✅ now chunk replies so the button can be placed before the form cleanly
if (Array.isArray(node.replies) && node.replies.length) {
  renderRepliesChunk(node, repliesContainer, depth, rootId, repliesBlock);
}

  thread.appendChild(repliesBlock);
  li.appendChild(thread);
  return li;
}

    // === Initial/refresh load (resets and gets first page) ===
    async function loadComments() {
      debug("loadComments()", productId);
      notify(wrapper, ''); // clear status

      // reset state
      allComments   = [];
      renderedCount = 0;
      nextCursor    = null;
      repliesMap.clear();
      list.innerHTML = '';

      try {
        // pull at least one page
        await fetchNextPage();
        // hydrate before counting/rendering
        allComments = await hydrateCommentsWithProfiles(allComments);
      } catch (e) {
        // fetchNextPage() already catches, but just in case
        debug('loadComments fetchNextPage() threw', e);
      }

      // If we still have nothing, show an empty/diagnostic state
      if (!Array.isArray(allComments) || allComments.length === 0) {
        list.innerHTML = `<li style="color:#888">No comments yet.</li>`;
        const countEl = wrapper.querySelector('#quick-comments-count');
        if (countEl) countEl.textContent = `(0)`;
        updateRootMoreVisibility(); // will hide the button if needed
        return;
      }

      // reactions object hardening for all fetched roots
      const ensureReacts = (n) => {
        if (!n || typeof n !== 'object') return;
        if (!n.reactions || typeof n.reactions !== 'object') n.reactions = {};
        Object.keys(n.reactions).forEach(k => {
          if (!REACTION_TYPES.includes(k)) delete n.reactions[k];
        });
        REACTION_TYPES.forEach(t => {
          const arr = Array.isArray(n.reactions[t]) ? n.reactions[t] : [];
          n.reactions[t] = Array.from(new Set(arr.filter(x => x != null).map(String)));
        });
        (Array.isArray(n.replies) ? n.replies : []).forEach(ensureReacts);
      };
      allComments.forEach(ensureReacts);

      // count (non-deleted) only among what we’ve fetched so far
      const countEl = wrapper.querySelector('#quick-comments-count');
      if (countEl) countEl.textContent = `(${countAllNonDeleted(allComments)})`;

      // render first page worth (or whatever we got)
      renderRootPage(true);
      refreshTimeAgo(wrapper);
    }

    // === Fetch one page from the server and append to allComments ===
    async function fetchNextPage() {
      if (isLoadingPage) return;
      isLoadingPage = true;
      try {
        const qs = new URLSearchParams();
        qs.set('limit', String(ROOT_PAGE_SIZE));
        if (nextCursor) qs.set('after', nextCursor);

        const url = `${API_BASE}/${productId}?${qs.toString()}`;
        debug('fetchNextPage ->', url);
        const data = await fetchJSON(url, { method: 'GET' }, wrapper);

        // Support BOTH shapes:
        // 1) Old: an array of roots
        // 2) New: { items: [...roots], nextCursor: "..." }
        let pageItems = [];
        let nc = null;

        if (Array.isArray(data)) {
          pageItems = data;
          nc = null;
        } else if (data && typeof data === 'object') {
          pageItems = Array.isArray(data.items) ? data.items : [];
          nc = data.nextCursor || null;
        }

        debug('fetchNextPage got', { count: pageItems.length, nextCursor: nc });

        if (pageItems.length) {
          // hydrate the new batch before merging
          pageItems = await hydrateCommentsWithProfiles(pageItems);
          allComments = allComments.concat(pageItems);
        }
        nextCursor = nc;

        // expose for quick inspection in DevTools
        window.__dbComments = { allComments, nextCursor };
      } catch (err) {
        debug('fetchNextPage error', err);
        // keep state as-is; user can retry
      } finally {
        isLoadingPage = false;
      }
    }

    function renderRootPage(reset) {
      if (reset) list.innerHTML = '';

      // If nothing fetched yet, keep a visible empty-state
      if (!Array.isArray(allComments) || allComments.length === 0) {
        if (!list.innerHTML.trim()) {
          list.innerHTML = `<li style="color:#888">No comments yet.</li>`;
        }
        updateRootMoreVisibility();
        return;
      }

      const next = Math.min(renderedCount + ROOT_PAGE_SIZE, allComments.length);

      for (let i = renderedCount; i < next; i++) {
        const root = allComments[i];
        try {
          if (!Array.isArray(root.replies)) root.replies = [];
          const rootLi = renderNode(root, 0, root.id);
          list.appendChild(rootLi);
        } catch (err) {
          // Don't let a single bad node kill the whole render
          console.warn('[db-comments] render root failed', root, err);
        }
      }

      renderedCount = next;
      updateRootMoreVisibility();
    }

  function updateRootMoreVisibility() {
    const remainingLocal = Math.max(0, allComments.length - renderedCount);
    if (remainingLocal > 0) {
      // We still have locally-fetched roots that are not rendered yet
      loadMoreRootBtn.textContent = `Load more (${remainingLocal})`;
      loadMoreRootBtn.hidden = false;
      return;
    }
    // Nothing left locally; show button only if server says more pages
    if (nextCursor) {
      loadMoreRootBtn.textContent = 'Load more';
      loadMoreRootBtn.hidden = false;
    } else {
      loadMoreRootBtn.hidden = true;
    }
  }

    await loadComments();

 if (window.DB_COMMENTS?.setLocalCount) {
   window.DB_COMMENTS.setLocalCount(productId, countAllNonDeleted(allComments));
 }

    // refresh "time ago" every minute (clear any previous timer on this container)
    if (containerEl._commentsTimeAgoTimer) {
      clearInterval(containerEl._commentsTimeAgoTimer);
    }
    containerEl._commentsTimeAgoTimer = setInterval(() => refreshTimeAgo(wrapper), 60 * 1000);

    // ── event delegation for Reply/Edit/Save/Cancel/Delete ─────────
    list.addEventListener('click', async (e) => {
      const li = e.target.closest('li.quick-comment, li.quick-reply');
      if (!li) return;
      const cid = li.dataset.id;
      const rootId = li.dataset.rootId || cid; // for root nodes, rootId === id
      const isReply = li.dataset.isReply === 'true';

      // Read more / Show less
      if (e.target.matches('.read-more')) {
        const btn   = e.target;
        const root  = btn.closest('.quick-thread');
        if (!root) return;

        const short = root.querySelector('.body-short');
        const full  = root.querySelector('.body-full');
        if (!short || !full) return;

        const showingFull = full.hidden === false;
        if (showingFull) {
          full.hidden  = true;
          short.hidden = false;
          btn.textContent = 'Read more';
        } else {
          full.hidden  = false;
          short.hidden = true;
          btn.textContent = 'Show less';
        }
        return;
      }

      // Per-branch: load more replies
      if (e.target.matches('.load-more-replies')) {
        const parentLi = e.target.closest('li.quick-comment, li.quick-reply');
        if (!parentLi) return;

        const parentId = parentLi.dataset.id;
        const rootId   = parentLi.dataset.rootId || parentId;
        const depth    = Number(parentLi.dataset.depth || 0);

        const block = parentLi.querySelector('.quick-replies-block');
        const repliesContainer = block?.querySelector('.quick-replies');
        if (!repliesContainer) return;

        // Use normalized key
        const state = repliesMap.get(keyOf(parentId));
        const parentNode = { id: parentId, replies: state?.all || [] };

        renderRepliesChunk(parentNode, repliesContainer, depth, rootId, block);
        refreshTimeAgo(wrapper);
        return;
      }

      // On-rail collapse/expand (hide replies only; keep the parent visible)
      if (e.target.matches('.rail-toggle')) {
        const btn = e.target;
        const closed = li.classList.toggle('collapsed');
        const count = btn.dataset.count || '0';
        btn.setAttribute('aria-expanded', closed ? 'false' : 'true');
        btn.title = closed ? `Show replies (${count})` : `Hide replies (${count})`;

        // persist
        const id = li.dataset.id;
        if (closed) collapsedSet.add(id);
        else collapsedSet.delete(id);
        saveCollapsed();
        return;
      }

    // 💟 Toggle reaction (exclusive: 👍 OR 👎, not both)
    if (e.target.closest('.quick-react-btn')) {
      const btn = e.target.closest('.quick-react-btn');
      if (!btn) return;

      const type    = btn.dataset.type;   // "👍" or "👎"
      const mine    = btn.getAttribute('aria-pressed') === 'true';
      const cid     = btn.dataset.commentId;
      const rootId  = btn.dataset.rootId;
      const isReply = btn.closest('li')?.classList.contains('quick-reply');

      const baseUrl = isReply
        ? `${API_BASE}/${productId}/${rootId}/replies/${cid}/reactions`
        : `${API_BASE}/${productId}/${cid}/reactions`;

      btn.disabled = true;

      try {
        if (mine) {
          // remove my reaction
          const myCustomerId = window.customer?.shopify_customer_id || window.customer?.id;
          const delUrl = `${baseUrl}?customerId=${encodeURIComponent(myCustomerId)}&type=${encodeURIComponent(type)}`;
          await fetchJSON(delUrl, { method: 'DELETE' }, wrapper);

          btn.setAttribute('aria-pressed', 'false');
          const countEl = btn.querySelector('.count');
          if (countEl) {
            const newCount = Math.max(0, parseInt(countEl.textContent) - 1);
            if (newCount === 0) {
              countEl.remove();
              btn.classList.remove('has-count');
            } else {
              countEl.textContent = newCount;
            }
          }
        } else {
          // add my reaction
          const reactPayload = {
            customerId: window.customer?.shopify_customer_id || window.customer?.id,
            type
          };
          await fetchJSON(baseUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(reactPayload)
          }, wrapper);

          // ✅ un-press opposite immediately
          const wrap = btn.closest('.quick-reactions');
          const opposite = wrap?.querySelector(
            `.quick-react-btn[data-type="${type === "👍" ? "👎" : "👍"}"]`
          );
          if (opposite && opposite.getAttribute('aria-pressed') === 'true') {
            opposite.setAttribute('aria-pressed', 'false');
            const oppCount = opposite.querySelector('.count');
            if (oppCount) {
              const newCount = Math.max(0, parseInt(oppCount.textContent) - 1);
              if (newCount === 0) {
                oppCount.remove();
                opposite.classList.remove('has-count');
              } else {
                oppCount.textContent = newCount;
              }
            }
          }

          // mark this button pressed
          btn.setAttribute('aria-pressed', 'true');
          let countEl = btn.querySelector('.count');
          if (countEl) {
            countEl.textContent = parseInt(countEl.textContent) + 1;
          } else {
            const span = document.createElement('span');
            span.className = 'count';
            span.textContent = '1';
            btn.appendChild(document.createTextNode(' '));
            btn.appendChild(span);
          }
          btn.classList.add('has-count');
        }

        afterXpAward();
        window.refreshEgAchievements?.();
      } catch (err) {
        debug('reaction toggle error', err);
      } finally {
        btn.disabled = false;
      }
      return;
    }

      // ⇄ Toggle reply form (and focus textarea)
      if (e.target.matches('.quick-reply-btn')) {
        const form = li.querySelector('.quick-reply-form');
        if (form) {
          // Pin the exact IDs we should use on submit
          form.dataset.parentId = li.dataset.id;                      // the node you're replying to
          form.dataset.rootId   = li.dataset.rootId || li.dataset.id; // root thread id

          const isOpen = form.style.display === 'block';
          form.style.display = isOpen ? 'none' : 'block';
          if (!isOpen) form.querySelector('.quick-reply-input')?.focus();
        }
        return;
      }

      // ✖ Cancel reply
      if (e.target.matches('.quick-reply-cancel-btn')) {
        const form = li.querySelector('.quick-reply-form');
        const input = li.querySelector('.quick-reply-input');
        if (input) input.value = '';
        if (form) form.style.display = 'none';
        return;
      }

      // ✅ Submit reply (always target the node you clicked)
      if (e.target.matches('.quick-reply-submit-btn')) {
        const form = li.querySelector('.quick-reply-form');
        const input = form?.querySelector('.quick-reply-input');
        const replyText = input?.value.trim();
        if (!replyText) return;

        const hp = form?.querySelector('.hp-input-reply')?.value || '';

        const parentId = form?.dataset.parentId || cid;
        const threadRootId = form?.dataset.rootId || rootId;

        const btn = form.querySelector('.quick-reply-submit-btn');
        btn.disabled = true;
        const oldLabel = btn.textContent;
        btn.textContent = 'Posting…';

        try {
          const replyPayload = {
            customerId: window.customer?.shopify_customer_id || window.customer?.id,
            text: replyText,
            parentId,
            hp,
            product: {
              title:  productTitle,
              handle: productHandle,
              image_url: productImage
            }
          };
          console.log("[db-comments] POST reply payload", replyPayload);

          const tree = await fetchJSON(`${API_BASE}/${productId}/${threadRootId}/replies`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(replyPayload)
          }, wrapper);
          afterXpAward(); // ← XP changed, refresh profile/stats now

          // 1) give the table an immediate +1
          window.dispatchEvent(new CustomEvent('gd:comment-added', {
            detail: { productId }
          }));
          // 2) then correct to the exact count from the server’s thread
          if (Array.isArray(tree) && window.DB_COMMENTS?.setLocalCount) {
            const visible = countAllNonDeleted(tree);
            window.DB_COMMENTS.setLocalCount(productId, visible);
          }
          // 3) refresh the widget UI
          await loadComments();
          window.refreshEgAchievements?.();
        } catch (err) {
          debug('reply post error', err);
        } finally {
          btn.disabled = false;
          btn.textContent = oldLabel;
        }
        return;
      }

      // ✏️ Start editing (root or reply)
      if (e.target.matches('.quick-comment-edit-btn')) {
        const orig = decodeURIComponent(li.dataset.text);
        const thread = li.querySelector('.quick-thread');
        if (!thread) return;
        thread.innerHTML = `
          <textarea class="edit-text"
            style="display:block;width:100%;margin-bottom:.5em;">${escapeHtml(orig)}</textarea>
          <div class="quick-comment-controls">
            <button class="save-edit-btn">Save</button>
            <button class="cancel-edit-btn">Cancel</button>
          </div>
        `;
        return;
      }

      // ❌ Cancel editing
      if (e.target.matches('.cancel-edit-btn')) {
        await loadComments();
        return;
      }

      // 💾 Save edit (root or reply)
      if (e.target.matches('.save-edit-btn')) {
        const newText = li.querySelector('.edit-text')?.value.trim();
        const originalText = decodeURIComponent(li.dataset.text || '').trim();
        if (newText === originalText) { await loadComments(); return; }
        if (!newText) return;

        const nowIso = new Date().toISOString();

        try {
          if (isReply) {
            await fetchJSON(`${API_BASE}/${productId}/${rootId}/replies/${cid}`, {
              method: 'PUT',
              headers: { 'Content-Type':'application/json' },
              body: JSON.stringify({
                customerId: window.customer?.shopify_customer_id || window.customer?.id,
                text: newText,
                editedAt: nowIso,
                hp: ''
              })
            }, wrapper);
          } else {
            await fetchJSON(`${API_BASE}/${productId}/${cid}`, {
              method: 'PUT',
              headers: { 'Content-Type':'application/json' },
              body: JSON.stringify({
                customerId: window.customer?.shopify_customer_id || window.customer?.id,
                text: newText,
                editedAt: nowIso,
                hp: ''
              })
            }, wrapper);
          }

          li.dataset.text = encodeURIComponent(newText);
          li.dataset.editedAt = nowIso;

          // force rerender without full reload
          const whenNode = li.querySelector('.quick-comments-author time.timeago');
          if (whenNode) {
            // remove any old edited badge
            li.querySelector('.edited-badge')?.remove();

            // insert fresh edited badge
            const badge = document.createElement('span');
            badge.className = 'edited-badge';
            badge.textContent = `(Edited ${new Date(nowIso).toLocaleString()})`;
            whenNode.insertAdjacentElement('afterend', badge);
          }

          await loadComments();
          window.refreshEgAchievements?.();
        } catch (err) {
          debug("edit error", err);
          await loadComments();
        }
        return;
      }

      // 🗑 Delete (root or reply)
      if (e.target.matches('.quick-comment-delete-btn')) {
        if (!confirm('Delete this comment?')) return;
        try {
          let tree; // <-- declare once so we can use it after the branch

          if (isReply) {
            tree = await fetchJSON(`${API_BASE}/${productId}/${rootId}/replies/${cid}`, {
              method: 'DELETE',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                customerId: window.customer?.shopify_customer_id || window.customer?.id,
                hp: ''
              })
            }, wrapper);
          } else {
            tree = await fetchJSON(`${API_BASE}/${productId}/${cid}`, {
              method: 'DELETE',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                customerId: window.customer?.shopify_customer_id || window.customer?.id,
                hp: ''
              })
            }, wrapper);
          }

          // XP changed due to delete (backend deducts from the original author)
          afterXpAward();

          // 1) instant -1 on the table badge
          window.dispatchEvent(new CustomEvent('gd:comment-removed', {
            detail: { productId }
          }));
          // 2) correct it using the server’s updated thread (if we have it)
          if (Array.isArray(tree) && window.DB_COMMENTS?.setLocalCount) {
            const visible = countAllNonDeleted(tree);
            window.DB_COMMENTS.setLocalCount(productId, visible);
          }

          await loadComments();
        } catch (err) {
          debug("delete error", err);
        }
        return;
      }
    });

    // Submit reply on Ctrl/Cmd + Enter
list.addEventListener('keydown', async (e) => {
  if (!e.target.matches('.quick-reply-input')) return;
  if (!(e.key === 'Enter' && (e.ctrlKey || e.metaKey))) return;

  const li = e.target.closest('li.quick-comment, li.quick-reply');
  if (!li) return;

  const form = li.querySelector('.quick-reply-form');
  if (!form) return;

  const btn = form.querySelector('.quick-reply-submit-btn');
  if (btn) btn.click();
});


// ── new root-comment form ──────────────────────────────────────
if (window.customerLoggedIn) {
  list.insertAdjacentHTML('beforebegin', `
    <form id="quick-comment-form" style="margin-bottom:1em;">
      <!-- Honeypot (spam trap). Humans won't see/focus this. -->
      <input type="text"
            class="hp-input-root"
            autocomplete="off"
            tabindex="-1"
            style="position:absolute;left:-9999px"
            aria-hidden="true">
      <textarea id="quick-text" required
        placeholder="Your comment…"
        style="display:block;width:100%;margin-bottom:.5em"></textarea>
      <button class="quick-comment-comment-btn" type="submit">Comment</button>
    </form>
  `);
    const form = wrapper.querySelector('#quick-comment-form');
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const text = form.querySelector('#quick-text').value.trim();
        if (!text) return;
        const hp = form.querySelector('.hp-input-root')?.value || '';
        const submitBtn = form.querySelector('.quick-comment-comment-btn');

        submitBtn.disabled = true;
        submitBtn.textContent = 'Posting…';
        try {
          const customerId = String(window.customer?.shopify_customer_id || window.customer?.id).replace(/\D/g,'');
          const cleanText  = String(text); // already trimmed above
          const compatPayload = {
            // current route expects these:
            customerId,
            text: cleanText,
            hp,

            // extra for older/staging variants (harmless if ignored):
            body: cleanText,
            productId: String(productId),

            // metadata is optional; safe to include
            product: {
              title:  productTitle || '',
              handle: productHandle || '',
              image_url: productImage || ''
            }
          };

          console.log('[db-comments] [FINAL PAYLOAD]', compatPayload);

          // Use native fetch with a plain JSON body; no custom headers except Content-Type.
          const res = await fetch(`${API_BASE}/${productId}`, {
            method: 'POST',
            mode: 'cors',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(compatPayload)
          });

          const raw = await res.text();
          console.log('[db-comments] RAW (native)', res.status, raw);
          if (!res.ok) throw new Error(raw || `HTTP ${res.status}`);

          afterXpAward();
          form.reset();
         // 1) immediate +1 on the table badge
         window.dispatchEvent(new CustomEvent('gd:comment-added', {
           detail: { productId }
         }));
         // 2) refresh the widget…
         await loadComments();
         // 3) …and set the exact total the widget just loaded
         if (window.DB_COMMENTS?.setLocalCount) {
           // `allComments` is in scope here
           window.DB_COMMENTS.setLocalCount(productId, countAllNonDeleted(allComments));
         }
          window.refreshEgAchievements?.();

        } catch (err) {
          debug('post error', err);
        } finally {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Comment';
        }
      });

    // Ctrl/Cmd + Enter submits root comment
    const rootTa = form.querySelector('#quick-text');
    rootTa.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
        form.requestSubmit(); // triggers the existing submit handler
      }
    });

    }
  } catch (err) {
    // Never let an error here break other features (like your quick view)
    console.error('[db-comments] init failed', err);
  }
};
})(window, document);